import { JobFormValues, STEP_SCHEMAS } from "../schema/jobForm.schema";
import { toJobPayload } from "./jobPayload";

// Paid duration, ownership/source, publication and payment are deliberately not editable here.
const EDIT_FIELDS = {
  title: ["title"], classification: ["classification", "discipline"],
  positionLevel: ["positionLevel"], location: ["location"], workPlaceOption: ["workPlaceOption"],
  jobType: ["jobType"], qualificationEligibility: ["qualificationEligibility"],
  compensationType: ["compensationType"], currency: ["currency"], salary: ["salaryMin", "salaryMax"],
  jobOverview: ["jobOverview"], keyResponsibilities: ["keyResponsibilities"],
  industryType: ["industryType"], salaryAndBenefits: ["salaryAndBenefits"],
  matchVisibilityMode: ["matchVisibilityMode"], reviewThreshold: ["reviewThreshold"],
  belowThresholdHandling: ["belowThresholdHandling"],
  queueHealthNotificationEnabled: ["queueHealthNotificationEnabled"], queueHealthMinimum: ["queueHealthMinimum"],
};

export function getJobEdits(values: JobFormValues, initial: JobFormValues) {
  const changed = new Set(Object.entries(values).filter(([key, value]) =>
    JSON.stringify(value) !== JSON.stringify(initial[key])).map(([key]) => key));
  const payload = toJobPayload(values);
  const updates = Object.fromEntries(Object.entries(EDIT_FIELDS)
    .filter(([, fields]) => fields.some(field => changed.has(field)))
    .map(([key]) => [key, payload[key]]));
  const errors: { step: number; path: string; message: string }[] = [];
  for (const step of [2, 3, 6]) {
    const result = STEP_SCHEMAS[step - 1].safeParse(values);
    if (!result.success) for (const issue of result.error.issues) {
      const field = String(issue.path[0]);
      const related = Object.values(EDIT_FIELDS).find(fields => fields.includes(field));
      if (changed.has(field) || related?.some(name => changed.has(name)) ||
        (field === "queueHealthMinimum" && changed.has("queueHealthNotificationEnabled"))) {
        errors.push({ step, path: issue.path.join("."), message: issue.message });
      }
    }
  }
  if (changed.has("salaryAndBenefits") && !values.salaryAndBenefits.trim()) {
    errors.push({ step: 3, path: "salaryAndBenefits", message: "Salary and benefits cannot be empty." });
  }
  if (values.skills.some(skill => !skill.isSaved)) {
    errors.push({ step: 4, path: "skills.root", message: "Save or remove unfinished skill requirements before saving the job." });
  }
  return { updates, errors };
}
